var React = require('react');

function Icons8Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.469 5C7.918 5 5 7.914 5 11.469v9.063C5 24.082 7.914 27 11.469 27h9.063C24.082 27 27 24.086 27 20.531v-9.062C27 7.918 24.086 5 20.531 5zm0 2h9.063C23.004 7 25 8.996 25 11.469v9.063C25 23.004 23.004 25 20.531 25h-9.062C8.996 25 7 23.004 7 20.531v-9.062C7 8.996 8.996 7 11.469 7zm10.438 2.188a.9.9 0 1 0 0 1.813.9.9 0 1 0 0-1.812zM16 10a6.02 6.02 0 0 0-6 6 6.02 6.02 0 0 0 6 6 6.02 6.02 0 0 0 6-6 6.02 6.02 0 0 0-6-6zm0 2a3.98 3.98 0 0 1 4 4 3.98 3.98 0 0 1-4 4 3.98 3.98 0 0 1-4-4 3.98 3.98 0 0 1 4-4z"}));
}

Icons8Instagram.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Icons8Instagram;

Icons8Instagram.default = Icons8Instagram;
